import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { connect } from "react-redux";
import * as urlService from "../../view/urlService";
import { debug } from "../../utils";
import { TableContext, PopupContext } from "../../index";
import { showSuccessToast } from "../../validation/ToastContainer";
import {
    acknowledgeValidationResult, getLastAnalysisDateTime,
    removeRulesFromWhitelist, exportAnalysisData
} from "../ruleService";
import { useInterval } from "../../hooks";
import { RemediationModal } from "../RemediationModal";
import { POPUP_TYPES } from "../../view/popup/PopupContainer";
import ActionTooltip from "../../view/ActionTooltip";
import { Download } from "lucide-react";


function AnalysisTableHeader({ whitelisted, validationResultList, currentUser, userCapability }) {

    const history = useHistory();
    const { config, setConfig } = useContext(TableContext);
    const { setPopup } = useContext(PopupContext);

    const selectedCount = config.selected?.length || 0;
    const isRemediateActive = selectedCount === 1;
    const [showModal, setShowModal] = useState(false);
    const [lastValidation, setLastValidation] = useState('N/A');
    const [lastRunTimestamp, setLastRunTimestamp] = useState(null);
    const [btnWhitelistName, setBtnWhitelistName] = useState('View Whitelist');
    //#region Set User Capabilities
    const [remediateCapability, setRemediateCapability] = useState(-1);
    const [clearwhitelistCapability, setClearwhitelistCapability] = useState(-1);
    const [acknowledgeCapability, setAcknowledgeCapability] = useState(-1);
    const [exportdataCapability, setExportdataCapability] = useState(-1);
    useEffect(() => {
        if (userCapability) {
            const remediatePermission = userCapability.find(item =>
                item.component === "analysisremediate" && item.type === "field")?.permission;
            setRemediateCapability(remediatePermission);
            const clearWhitelistPermission = userCapability.find(item =>
                item.component === "analysisclearwhitelist" && item.type === "field")?.permission;
            setClearwhitelistCapability(clearWhitelistPermission);
            const acknowledgePermission = userCapability.find(item =>
                item.component === "analysisacknowledge" && item.type === "field")?.permission;
            setAcknowledgeCapability(acknowledgePermission);
            const exportDataPermission = userCapability.find(item =>
                item.component === "analysisexportdata" && item.type === "field")?.permission;
            setExportdataCapability(exportDataPermission);
        }
        /* eslint-disable react-hooks/exhaustive-deps */
    }, []);
    //#endregion

    useEffect(() => {
        getLastValidationTime();
    }, [])

    useInterval(() => getLastValidationTime(), 3500);

    const getLastValidationTime = async () => {
        let time = 'N/A';
        //setLastValidation(time);
        if (validationResultList.length <= 0) {
            setLastValidation(time);
            return;
        }
        //const selectedDeviceId = validationResultList[0].devicePk;
        const response = await getLastAnalysisDateTime();

        if (response && typeof response === "number") {
            //alert(12);            
            const dateObject = new Date(response);
            time = dateObject.toLocaleString();
            //time = moment(response).local().format('YYYY-MM-DD HH:MM:SS');
            if (lastRunTimestamp && lastRunTimestamp !== response) {
                //alert(13);
                setLastRunTimestamp(lastRunTimestamp);
                setConfig({ ...config, lastUpdated: Date.now() });
            }
        }
        if (lastValidation !== time) {
            //alert(14);
            setLastValidation(time);
            setConfig({ ...config, lastUpdated: Date.now() });
        }
    }

    const acknowledgeBtnDisabled = () => {
        const { deviceId } = config;

        if (!deviceId) {
            return true;
        }

        if (config.selected.length === 0) {
            return true
        }

        if (btnWhitelistName === 'Clear Whitelist') {
            return true;
        }

        return Number(deviceId) < 0;
    }

    // const onAcknowledgeClick = async () => {

    //     if (!config.selected || !config.selected.length) {
    //         return showWarningToast('No selected rows found', 'Acknowledge');
    //     }

    //     await acknowledgeValidationResult(config.selected, 1)
    //         .then(() => showSuccessToast('Validation result was added to the whitelist', 'Acknowledge'))
    //         .then(() => setConfig({ ...config, lastUpdated: Date.now() }))
    // }

    const whitelistedLength = () => {
        if (btnWhitelistName === 'View Whitelist') {
            return whitelisted;
        }
        else if (btnWhitelistName === 'Clear Whitelist') {
            return config.selected.length;
        }
        return 0;
    }

    const onWhitelistClick = async () => {
        //const { deviceId } = config;

        if (whitelistedLength() === 0) {
            return;
        }
        if (btnWhitelistName === 'View Whitelist') {
            setBtnWhitelistName('Clear Whitelist');
            history.push({
                pathname: history.pathname,
                search: urlService.updateFilters('whitelist', true)
            })
        }
        else if (btnWhitelistName === 'Clear Whitelist') {
            const selected = config.selected;
            if (selected.length > 0) {
                await removeRulesFromWhitelist(selected, 1)
                    .then(response => response && showSuccessToast('Validation selected whitelist cleared', 'Clear Whitelist'))
                    .then(() => setConfig({ ...config, lastUpdated: Date.now() }))
            }
        }
    }

    const onAcknowledgeClick = async () => {
        if (!config.selected || !config.selected.length || acknowledgeBtnDisabled()) {
            return; //showWarningToast('No selected rows found', 'Acknowledge');
        }
        onAddAcknowledgeExpiryDate();
    }

    const onAddAcknowledgeExpiryDate = () => setPopup(
        {
            type: POPUP_TYPES.ADD_ACKNOWLEDGE_EXPIRY_DATE,
            selectedDate: new Date(),
            comment: "",
            confirm: confirmAcknowledgeCreation
        }
    );

    const confirmAcknowledgeCreation = async (selectedDate, comment) => {
        if (!config.selected || !config.selected.length) {
            return; //showWarningToast('No selected rows found', 'Acknowledge');
        }

        let expiryDate;
        if (selectedDate) {
            const endOfDay = new Date(selectedDate);
            endOfDay.setHours(23, 59, 59, 999); // Set time to 11:59:59.999
            expiryDate = Math.floor(endOfDay.getTime());
        } else {
            expiryDate = null;
        }

        // const endOfDay = new Date(selectedDate);
        // endOfDay.setHours(23, 59, 59, 999); // Set time to 11:59:59.999
        // const expiryDate = Math.floor(endOfDay.getTime());
        await acknowledgeValidationResult(config.selected, expiryDate, comment, 1)
            .then(() => showSuccessToast('Analysis result was added to the whitelist', 'Acknowledge'))
            .then(() => setConfig({ ...config, lastUpdated: Date.now() }))
    };

    const onViewValidationResultClick = async () => {
        setBtnWhitelistName('View Whitelist');
        history.push({
            pathname: history.pathname,
            search: urlService.removeFilter('whitelist')
        })
    }

    const showRemediate = () => {
        const validationResult = validationResultList.find(vr => vr.id === config?.selected[0]);
        if (validationResult) {
            return <RemediationModal ruleId={validationResult.rulePk}
                deviceId={validationResult.devicePk}
                realTime={1}
                resultId={validationResult.id}
                validationResult={validationResult}
                closeModal={() => setShowModal(false)}
                currentUser={currentUser}
                disabled={remediateCapability === 0 ? true : false} />
        } else {
            return null;
        }
    }

    const exportData = () => {

        exportAnalysisData();
    }

    const remediateTooltip = selectedCount === 2
        ? 'You cannot remediate more than one rule at a time.'
        : '';

    return (
        <>
            {showModal && showRemediate()}
            <div className="oct_analysis-header-v2">
                <div className="oct_analysis-title-section">
                    <h2>CONFIGURATION DIFFERENCES</h2>
                    <div className="oct_last-analysis" data-toggle="tooltip"
                        title="Last Analysis date">Last analysis: {lastValidation}</div>
                </div>
                <div className="oct_analysis-actions">
                    {btnWhitelistName === 'Clear Whitelist' &&
                        <button
                            onClick={() => onViewValidationResultClick()}
                            className="oct_btn-outline-v2">
                            View Results
                        </button>
                    }

                    <ActionTooltip
                        title={!isRemediateActive ? remediateTooltip : ""}
                        placement="top">
                        <button
                            onClick={() => setShowModal(true)}
                            className="oct_btn-outline-v2"
                            disabled={!isRemediateActive}
                            style={!isRemediateActive ? { pointerEvents: 'none' } : undefined}>
                            Remediate
                        </button>
                    </ActionTooltip>

                    <button
                        onClick={clearwhitelistCapability === 0 ? null : () => onWhitelistClick()}
                        className="oct_btn-outline-v2"
                        disabled={!whitelistedLength() || clearwhitelistCapability === 0}>
                        <span>{btnWhitelistName}</span>
                        {whitelistedLength() ? <span>({whitelistedLength()})</span> : null}
                    </button>

                    <button
                        onClick={acknowledgeCapability === 0 ? null : () => onAcknowledgeClick()}
                        className="oct_btn-outline-v2"
                        disabled={acknowledgeBtnDisabled() || acknowledgeCapability === 0}>
                        Acknowledge
                    </button>

                    <button
                        onClick={exportdataCapability === 0 ? null : exportData}
                        className="oct_btn-export-v2"
                        disabled={exportdataCapability === 0}>
                        <Download className="oct_icon" />
                        Export Data
                    </button>
                </div>
            </div>
            {/*
            <div className="mr-4 mb-4 mt-4">
                <SearchInputV2
                    value={searchTerm}
                    onChange={(e) => {
                        const value = e.target.value;
                        setSearchTerm(value);
                        setConfig({ ...config, searchTerm: value });
                    }}
                    placeholder="Search by rule name, description, or severity..."
                />
            </div>
            */}
        </>
    );
}

function mapStateToProps(state) {
    debug("AnalysisTableHeader mapStateToProps", state);
    const auth = state.auth;
    const analysisPage = state.analysisPage;
    const metadata = analysisPage.metadata || {};
    const validationResultList = analysisPage.validationResultList || [];

    return {
        whitelisted: metadata.whitelisted || 0,
        validationResultList,
        currentUser: auth.firstName + ' ' + auth.lastName,
        userCapability: auth.userCapability
    }
}

export default connect(mapStateToProps)(AnalysisTableHeader);
